// extracted by mini-css-extract-plugin
export default {"button":"button-_i486","pencilIcon":"pencilIcon-qLPtq"};